import { styled } from '@abyss/web/tools/styled';
import { Button } from '@abyss/web/ui/Button';

export const FilterPopOverWrapper = styled('div', {
  '.abyss-popover-trigger ~ div': {
    zIndex: '999 !important',
  },
  '.abyss-popover-trigger': {
    borderRadius: '8px',
  },
});

export const FilterToggleButton = styled('div', {
  height: '40px',
  fontSize: '16px',
  padding: '20px',
  border: '1px solid $gray4',
  borderRadius: '240px',
  display: 'flex',
  alignItems: 'center',
  gap: '$xs',
  '&.selected': {
    background: '$tint3',
  },
  '&.map-view': {
    background: '#FFFFFF',
  },
  '&.unset': {
    background: 'unset',
  },
});

export const FilterToggleButtonDisabled = styled(Button, {
  '&.abyss-button-root': {
    border: '1px solid $core.color.neutral.30 !important',
    fontWeight: '$semibold',
  },
});
